import { z } from 'zod';


const createMedicalLeaveBaseSchema = z.object({
  employeeTargetId: z.union([
    z.coerce
      .number({ invalid_type_error: 'absence:medicalLeave.validation.employeeRequired' })
      .int()
      .positive('absence:medicalLeave.validation.employeeRequired'),
    z.null(),
  ]),
  leaveTypeId: z.union([
    z.coerce
      .number({ invalid_type_error: 'absence:medicalLeave.validation.leaveTypeRequired' })
      .int()
      .positive('absence:medicalLeave.validation.leaveTypeRequired'),
    z.null(),
  ]),
  startDate: z
    .string()
    .min(1, 'absence:medicalLeave.validation.startDateRequired')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'absence:medicalLeave.validation.invalidDateFormat'),
  endDate: z
    .string()
    .min(1, 'absence:medicalLeave.validation.endDateRequired')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'absence:medicalLeave.validation.invalidDateFormat'),
  folio: z
    .string()
    .min(1, 'absence:medicalLeave.validation.folioRequired')
    .max(50, 'absence:medicalLeave.validation.folioMaxLength'),
  workdayType: z.string().min(1, 'absence:medicalLeave.validation.workdayTypeRequired'),
  dayCount: z.union([
    z.coerce
      .number({ invalid_type_error: 'absence:medicalLeave.validation.dayCountRequired' })
      .int('absence:medicalLeave.validation.dayCountInteger')
      .positive('absence:medicalLeave.validation.dayCountRequired'),
    z.null(),
  ]),
  returnDate: z.string().optional().default(''),
});

export const createMedicalLeaveFormSchema = createMedicalLeaveBaseSchema
  .refine((data) => data.employeeTargetId !== null, {
    message: 'absence:medicalLeave.validation.employeeRequired',
    path: ['employeeTargetId'],
  })
  .refine((data) => data.leaveTypeId !== null, {
    message: 'absence:medicalLeave.validation.leaveTypeRequired',
    path: ['leaveTypeId'],
  })
  .refine((data) => data.dayCount !== null, {
    message: 'absence:medicalLeave.validation.dayCountRequired',
    path: ['dayCount'],
  })
  .refine(
    (data) => {
      if (!data.startDate || !data.endDate) return true;
      return data.endDate >= data.startDate;
    },
    {
      message: 'absence:medicalLeave.validation.endDateBeforeStartDate',
      path: ['endDate'],
    },
  );

export type CreateMedicalLeaveFormValues = z.infer<typeof createMedicalLeaveFormSchema>;
